import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntPlakette: SelectDataObject[] = [
    { i: 0, t: 'keine Plakette' },
    { i: 1, t: 'GRÜN', img: '/images/plakette/GRUN.png', imgRatio: [1, 1] },
    { i: 2, t: 'GELB', img: '/images/plakette/GELB.png', imgRatio: [1, 1] },
    { i: 3, t: 'ROT', img: '/images/plakette/ROT.png', imgRatio: [1, 1] },
];
export default sIntPlakette;
